export function extractURL(html) {
    const regex = /<p>(https?:\/\/.*?)<\/p>/;
    const match = html.match(regex);
    if (match && match[1]) {
        return match[1];
    } else {
        return null;
    }
}